import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import 'focus-visible/dist/focus-visible';
import React from 'react';
import baseTheme from '../../theme';
import { Fonts } from '../fonts';
export const DesignSystemProvider = (props)=>{
    const { theme ={} , children  } = props;
    const finalTheme = extendTheme(baseTheme, theme);
    return /*#__PURE__*/ React.createElement(ChakraProvider, {
        theme: finalTheme
    }, /*#__PURE__*/ React.createElement(Fonts, null), children);
};

//# sourceMappingURL=design-system-provider.js.map